import clsx from "clsx";
import React, { forwardRef, PropsWithChildren } from "react";

export interface FormFieldContainerProps {
  className?: string;
  disabled?: boolean;
}

export const FormFieldContainer = forwardRef<
  HTMLDivElement,
  PropsWithChildren<FormFieldContainerProps>
>(({ className, disabled, children }, ref) => {
  return (
    <div ref={ref} className={clsx(className, disabled && "opacity-50 cursor-not-allowed")}>
      {children}
    </div>
  );
});
